import React from "react"
import { useTranslation } from "react-i18next"
import { Typography } from "@mui/material"

import { formatMoney } from "helpers/formatters"
import { SubscriptionType } from "types"

type Props = {
  subscription: SubscriptionType
}

const PlanComponent = ({ subscription }: Props) => {
  const { t } = useTranslation()

  const { plan } = subscription
  const { price, plan_period } = plan

  return (
    <>
      {plan && price && plan_period && (
        <>
          <Typography component="span" variant="body2">
            {formatMoney(price)}
          </Typography>
          &nbsp;
          <Typography component="span" variant="body1">
            {t(`features.subscription.plan.period.${plan_period}.title`)}
          </Typography>
        </>
      )}
    </>
  )
}

export default PlanComponent
